import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import { useMobile } from '@/hooks'
import useTicketTypes from '@/hooks/useTicketTypes/useTicketTypes'

import MobileTicketTypeCard from './MobileTicketTypeCard'
import { TicketTypeListColumns } from './TicketTypes.data'

export function TicketTypes() {
  const { data: ticketTypesData, isLoading } = useTicketTypes()

  const { isMobile } = useMobile()

  const data = useMemo(() => {
    return ticketTypesData && ticketTypesData?.ticketTypes.length > 0 ? ticketTypesData?.ticketTypes : []
  }, [ticketTypesData])

  const columns = useMemo(() => {
    return TicketTypeListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            data.length > 0 ? (
              data.map((ticketType) => <MobileTicketTypeCard key={ticketType.id} ticketType={ticketType} />)
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
